import React from 'react';
const TaskTable = () => {
  const tasks = [{
    id: 1,
    task: 'Onboarding (begonnen): Agile Actors Hellas Single Member S',
    note: 'Sie werden täglich benachrichtigt',
    dueDate: '28.01.25, 01:00',
    openSince: '26.01.25, 10:35'
  }, {
    id: 2,
    task: 'Offene Fragen: TEXBAU 637463',
    note: 'Sie werden täglich benachrichtigt',
    dueDate: '22.05.25, 02:00',
    openSince: '22.05.25, 14:14'
  }, {
    id: 3,
    task: 'Onboarding (begonnen): Century Direct Printing',
    note: 'Sie werden täglich benachrichtigt',
    dueDate: '27.05.25, 02:00',
    openSince: '27.05.25, 14:42'
  }, {
    id: 4,
    task: 'Dokument (begonnen): CoC',
    note: 'Sie werden wöchentlich benachrichtigt',
    dueDate: '20.08.25, 02:00',
    openSince: '20.08.25, 16:32'
  }];
  return <div className="bg-white rounded shadow" data-id="element-966">
      <div className="p-4 border-b border-gray-200" data-id="element-967">
        <h2 className="text-base font-semibold text-gray-800" data-id="element-968">Aufgaben</h2>
      </div>
      <div className="overflow-x-auto" data-id="element-969">
        <table className="min-w-full" data-id="element-970">
          <thead className="bg-gray-100" data-id="element-971">
            <tr data-id="element-972">
              <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-16" data-id="element-973">
                Status
              </th>
              <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-974">
                Aufgabe
                <button className="ml-1 text-xs" data-id="element-975">↓</button>
              </th>
              <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-976">
                Fälligkeitsdatum
                <button className="ml-1 text-xs" data-id="element-977">↓</button>
              </th>
              <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-978">
                Offen seit
                <button className="ml-1 text-xs" data-id="element-979">↓</button>
              </th>
            </tr>
          </thead>
          <tbody className="bg-white" data-id="element-980">
            {tasks.map(task => <tr key={task.id} className="border-t border-gray-100" data-id="element-981">
                <td className="px-4 py-3 whitespace-nowrap" data-id="element-982">
                  <div className="flex items-center justify-center" data-id="element-983">
                    <div className="h-4 w-4 rounded-full border border-gray-300 flex items-center justify-center" data-id="element-984"></div>
                  </div>
                </td>
                <td className="px-4 py-3" data-id="element-985">
                  <div className="text-sm text-blue-600" data-id="element-986">{task.task}</div>
                  <div className="text-xs text-gray-500" data-id="element-987">{task.note}</div>
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500" data-id="element-988">
                  {task.dueDate}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500" data-id="element-989">
                  {task.openSince}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      
    </div>;
};
export default TaskTable;